import { all, takeEvery, takeLatest } from "redux-saga/effects";

import actions from "@/actions";

import addLights from "./add-lights";
import alignLights from "./align-lights";
import changeMode from "./change-mode";
import checkFloorspaceCatalogs from "./check-floorspace-catalogs";
import copy from "./copy";
import deleteLights from "./delete-lights";
import deleteMarkers from "./delete-markers";
import highlightMap from "./highlight-map";
import loadRequirements from "./load-requirements/load-requirements";
import paste from "./paste";
import persistGroup from "./persist-group";
import persistModeLights from "./persist-mode-lights";
import publishAllLightGroupSettings from "./publish-all-light-group-settings";
import rotateLights from "./rotate-lights/rotate-lights";
import runDuplicates from "./run-duplicates";
import saveAndPublishLightGroupSettings from "./save-and-publish-light-group-settings";
import saveChanges from "./save-changes/save-changes";
import { onlySaveLightGroupSettings } from "./save-light-group-settings";
import saveSettings from "./save-settings/save-settings";
import selectBLE from "./select-ble";
import selectMatches from "./select-matches";
import selectTool from "./select-tool";
import shiftLights from "./shift-lights/shift-lights";
import startDimTest from "./start-dimming";
import togglePasteMode from "./toggle-paste-mode";
import uncatalogLights from "./uncatalog-lights";
import uploadJsonFile from "./upload-json-file/upload-json-file";

/**
 * Root map saga that registers all map-related action watchers.
 *
 * @yields Registers all map-related action watchers.
 */
export default function* saga() {
    yield all([
        takeLatest(
            actions.map.types.GENERAL.LOAD_REQUIREMENTS,
            loadRequirements,
        ),
        takeLatest(actions.map.types.GENERAL.SAVE_SETTINGS, saveSettings),
        takeLatest(
            actions.map.types.GENERAL.PERSIST_MODE_LIGHTS,
            persistModeLights,
        ),
        takeLatest(actions.map.types.GENERAL.CHANGE_MODE, changeMode),
        takeLatest(actions.map.types.VALUES.MODE.ALIGN_LIGHTS, alignLights),
        takeLatest(actions.map.types.VALUES.MODE.ROTATE_LIGHTS, rotateLights),
        takeLatest(actions.map.types.VALUES.MODE.ADD_LIGHTS, addLights),
        takeLatest(actions.map.types.GENERAL.COPY, copy),
        takeLatest(actions.map.types.GENERAL.PASTE, paste),
        takeLatest(
            actions.map.types.GENERAL.TOGGLE_PASTE_MODE,
            togglePasteMode,
        ),
        takeLatest(actions.map.types.GENERAL.DELETE_LIGHTS, deleteLights),
        takeLatest(actions.map.types.GENERAL.DELETE_MARKERS, deleteMarkers),
        takeLatest(
            actions.map.types.GENERAL.CHECK_FLOORSPACE_CATALOGS,
            checkFloorspaceCatalogs,
        ),
        takeLatest(actions.map.types.GENERAL.SELECT_BLE, selectBLE),
        takeLatest(actions.map.types.GENERAL.SELECT_MATCHES, selectMatches),
        takeLatest(actions.map.types.GENERAL.SELECT_TOOL, selectTool),
        takeLatest(actions.map.types.GENERAL.HIGHLIGHT_MAP, highlightMap),
        takeEvery(actions.map.types.GENERAL.SAVE_CHANGES, saveChanges),
        takeLatest(actions.map.types.GENERAL.RUN_DUPLICATES, runDuplicates),
        takeLatest(
            actions.map.types.ADVANCED_OPERATIONS.SHIFT_LIGHTS,
            ({ payload }) => shiftLights(payload.x, payload.y),
        ),
        takeLatest(
            actions.map.types.ADVANCED_OPERATIONS.UPLOAD_JSON_FILE,
            uploadJsonFile,
        ),
        takeLatest(actions.map.types.GENERAL.PERSIST_GROUP, persistGroup),
        takeEvery(actions.map.types.GENERAL.START_DIM_TEST, startDimTest),
        takeEvery(
            actions.map.types.GENERAL.SAVE_AND_PUBLISH_LIGHT_GROUP_SETTINGS,
            saveAndPublishLightGroupSettings,
        ),
        takeEvery(
            actions.map.types.GENERAL.SAVE_LIGHT_GROUP_SETTINGS,
            onlySaveLightGroupSettings,
        ),
        takeEvery(
            actions.map.types.GENERAL.PUBLISH_ALL_LIGHT_GROUP_SETTINGS,
            publishAllLightGroupSettings,
        ),
        takeLatest(actions.map.types.GENERAL.UNCATALOG_LIGHTS, uncatalogLights),
    ]);
}
